export default __webpack_public_path__ + "static/media/M05.3ebf5169.svg";